__turbopack_context__.v({
  "actions": "TrashNotification-module___JsBlq__actions",
  "trashToast": "TrashNotification-module___JsBlq__trashToast",
});
